module.exports = __webpack_public_path__ + "static/media/icon.da1642a6.svg";